var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefereeConcierge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.4062 34.6875H33.6196L32.733 30.9384C32.6112 30.4236 32.1738 30.0625 31.6719 30.0625H27.8438V28.3281H31.125C31.7291 28.3281 32.2188 27.8104 32.2188 27.1719C32.2188 26.5333 31.7291 26.0156 31.125 26.0156V25.4375C31.125 18.1762 25.821 12.2006 19.0938 11.6111V9.82812H20.7344C21.3385 9.82812 21.8281 9.31041 21.8281 8.67188C21.8281 8.03334 21.3385 7.51562 20.7344 7.51562H15.2656C14.6615 7.51562 14.1719 8.03334 14.1719 8.67188C14.1719 9.31041 14.6615 9.82812 15.2656 9.82812H16.9062V11.6111C10.179 12.2006 4.875 18.1762 4.875 25.4375V26.0156C4.27091 26.0156 3.78125 26.5333 3.78125 27.1719C3.78125 27.8104 4.27091 28.3281 4.875 28.3281H8.15625V30.0625H4.32812C3.82623 30.0625 3.3888 30.4236 3.26705 30.9384L2.38036 34.6875H1.59375C0.989658 34.6875 0.5 35.2052 0.5 35.8438C0.5 36.4823 0.989658 37 1.59375 37H34.4062C35.0103 37 35.5 36.4823 35.5 35.8438C35.5 35.2052 35.0103 34.6875 34.4062 34.6875ZM7.0625 25.4375C7.0625 19.0619 11.969 13.875 18 13.875C24.031 13.875 28.9375 19.0619 28.9375 25.4375V26.0156C25.6133 26.0156 8.04024 26.0156 7.0625 26.0156V25.4375ZM10.3438 28.3281H25.6562V30.0625H10.3438V28.3281ZM4.6352 34.6875L5.18207 32.375H30.8179L31.3648 34.6875H4.6352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.59375 19.6562H3.78125C4.38534 19.6562 4.875 19.1385 4.875 18.5C4.875 17.8615 4.38534 17.3438 3.78125 17.3438H1.59375C0.989658 17.3438 0.5 17.8615 0.5 18.5C0.5 19.1385 0.989658 19.6562 1.59375 19.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.2188 19.6562H34.4062C35.0103 19.6562 35.5 19.1385 35.5 18.5C35.5 17.8615 35.0103 17.3438 34.4062 17.3438H32.2188C31.6147 17.3438 31.125 17.8615 31.125 18.5C31.125 19.1385 31.6147 19.6562 32.2188 19.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.1724 8.68871C7.5995 9.14022 8.29205 9.14029 8.71916 8.68871C9.14634 8.23712 9.14634 7.50507 8.71916 7.05355L7.17233 5.41825C6.74522 4.96674 6.05267 4.96667 5.62556 5.41825C5.19838 5.86984 5.19838 6.60189 5.62556 7.05341L7.1724 8.68871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.0542 9.02766C28.3341 9.02766 28.614 8.91471 28.8275 8.68902L30.3744 7.05387C30.8016 6.60228 30.8016 5.87023 30.3744 5.41871C29.9473 4.9672 29.2548 4.9672 28.8276 5.41871L27.2808 7.05387C26.5898 7.78426 27.0886 9.02766 28.0542 9.02766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18 4.625C18.6041 4.625 19.0938 4.10729 19.0938 3.46875V1.15625C19.0938 0.517711 18.6041 0 18 0C17.3959 0 16.9062 0.517711 16.9062 1.15625V3.46875C16.9062 4.10729 17.3959 4.625 18 4.625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefereeConcierge);
export default __webpack_public_path__ + "static/media/referee_concierge.3cede5f1814088f457a5416ce83743dc.svg";
export { ForwardRef as ReactComponent };